import { useHistory, useLocation } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import { isNotAuthenticated } from "utils/errors";
import { toLoginUrl } from "utils/intendedUrl";

const useRedirectOnUnauthenticated = () => {
	const history = useHistory();
	const location = useLocation();

	return (statusCode) => {
		if (isNotAuthenticated(statusCode)) {
			reactLocalStorage.clear();
			return history.push(toLoginUrl(location));
		}

		return;
	};
};

export default useRedirectOnUnauthenticated;
